import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PopupService } from '../../shared/modal/popup.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TreeService } from '../../shared/tree/tree.service';
import { TreeComponent } from '../../shared/tree';
import { GermplasmTreeService } from '../../shared/tree/germplasm/germplasm-tree.service';
import { ParamContext } from '../../shared/service/param.context';
import { GermplasmManagerContext } from '../germplasm-manager.context';
import { finalize } from 'rxjs/internal/operators/finalize';
import { TreeNode as PrimeNgTreeNode } from 'primeng/api';
import { ModalConfirmComponent } from '../../shared/modal/modal-confirm.component';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '../../shared/alert/alert.service';
import { GermplasmListService } from '../../shared/germplasm-list/service/germplasm-list.service';
import { JhiEventManager } from '../../shared/core-utils';
import { GermplasmListManagerContext } from '../../germplasm-list/germplasm-list-manager.context';

@Component({
    selector: 'jhi-germplasm-list-add',
    templateUrl: './germplasm-list-add.component.html',
    providers: [
        { provide: TreeService, useClass: GermplasmTreeService },
        GermplasmListService
    ]
})
export class GermplasmListAddComponent extends TreeComponent {

    selectedNode: PrimeNgTreeNode;

    isLoading: boolean;

    constructor(private modal: NgbActiveModal,
                public service: TreeService,
                public activeModal: NgbActiveModal,
                private paramContext: ParamContext,
                private germplasmManagerContext: GermplasmManagerContext,
                public germplasmListService: GermplasmListService,
                public alertService: AlertService,
                public translateService: TranslateService,
                public modalService: NgbModal,
                public eventManager: JhiEventManager,
                private germplasmListManagerContext: GermplasmListManagerContext
    ) {
        // TODO See if it's possible and makes sense to use selectedNodes and selectionMode from base component
        super(service, modal, alertService, translateService, modalService);
        this.selectionMode = 'single';
        if (!this.paramContext.cropName) {
            this.paramContext.readParams();
        }
    }

    validate() {
        if (!this.selectedNode) {
            this.alertService.error('germplasm-list-add.error.no-list-selected');
            return;
        }

        if (this.selectedNode.data.id === 'CROPLISTS' ||
            this.selectedNode.data.id === 'LISTS' ||
            this.selectedNode.data.type === 'LIST FOLDER') {
            this.alertService.error('germplasm-list-add.error.folder-selected');
            return;
        }

        this.confirmAddEntries();
    }

    confirmAddEntries() {
        let message = '';
        if (this.selectedNode) {
            message = this.translateService.instant('germplasm-list-add.add-question',
                { param: this.selectedNode.data.name });
        } else {
            return;
        }

        const confirmModalRef = this.modalService.open(ModalConfirmComponent as Component);
        confirmModalRef.componentInstance.message = message;
        confirmModalRef.componentInstance.title = this.translateService.instant('germplasm-list-add.header');

        confirmModalRef.result.then(() => {
            const persistPromise = this.persistTreeState();
            persistPromise.then(() => {
                this.submitAddEntries();
            });

        }, () => confirmModalRef.dismiss());
    }

    submitAddEntries() {
        this.isLoading = true;

        if (this.germplasmListManagerContext.activeGermplasmListId) {
            this.germplasmListService.addGermplasmListEntriesToAnotherList(this.selectedNode.data.id,
                this.germplasmListManagerContext.activeGermplasmListId, this.germplasmListManagerContext.searchComposite)
                .pipe(finalize(() => {
                    this.isLoading = false;
                })).subscribe(
                    (res: void) => this.onSaveSuccess()
                );
        } else {
            this.germplasmListService.addGermplasmEntriesToList(this.selectedNode.data.id, this.germplasmManagerContext.searchComposite)
                .pipe(finalize(() => {
                    this.isLoading = false;
                })).subscribe(
                    (res: void) => this.onSaveSuccess()
                );
        }
    }

    private onSaveSuccess() {
        if (this.germplasmListManagerContext.activeGermplasmListId) {
            this.eventManager.broadcast({ name: 'addToGermplasmList', content: parseInt(this.selectedNode.data.id, 10) });
        } else {
            // Show success message for instance where add to list is called in germplasm manager
            this.alertService.success('germplasm-list.list-data.add-entries.success');
        }
        this.modal.close();
    }

}

@Component({
    selector: 'jhi-germplasm-list-add-popup',
    template: ''
})
export class GermplasmListAddPopupComponent implements OnInit {
    constructor(private route: ActivatedRoute,
                private popupService: PopupService) {
    }

    ngOnInit(): void {
        const modal = this.popupService.open(GermplasmListAddComponent as Component, { size: 'xl', backdrop: 'static' });
    }

}
